<script lang="ts">
  import type { ProjectConfig } from '../../modules/projects/project.interface';
  import type { Report } from '../../modules/report/report.interface';
  import type { PaginateResult } from '../../types/paginate';
  import dayjs from 'dayjs';
  import { push } from 'svelte-spa-router';
  import Scroller from '../Scroller.svelte';
  import {
    List,
    ListItem,
    DataTable,
    DataTableHead,
    DataTableRow,
    DataTableCell,
    DataTableBody,
  } from 'svelte-materialify';
  import { QueryGroup, queryHistogram, QueryInterval } from '../../lib/pandalytics';

  export let reportsInfoResponse: PaginateResult<Report>;
  export let projectConfig: ProjectConfig;
  let response;
  function openReportPage(report: Report) {
    push(`/report/${projectConfig.key}/${report.date}`);
  }

  async function responseCounts() {
    const reports = reportsInfoResponse.docs;
    const startDate = reports[reports.length - 1].date;
    const endDate = reports[0].date;
    response = await queryHistogram({
      project: projectConfig.key,
      startDate: new Date(startDate),
      endDate: new Date(endDate),
      actions: ['REPORT_OPEN', 'ITEM_CLICK', 'BOOKMARK_ADD', 'SCROLL_PERCENTAGE'],
      groupBy: QueryGroup.Action,
      interval: QueryInterval.Day,
    });
    response = response['columns'];
  }

  if (reportsInfoResponse.docs.length) {
    responseCounts();
  }

  function filterViewCount(res, date, countType) {
    const reportByDay = res.find((e) => {
      return dayjs(e['timestamp']).format() === dayjs(date).format();
    });

    if (reportByDay?.['data']) {
      let eventType = Object.values(reportByDay['data']).find((e) => {
        return e['key'] === countType;
      });
      return eventType?.['doc_count'] || '0';
    } else {
      return '0';
    }
  }
</script>

<Scroller>
  {#if reportsInfoResponse.docs.length}
    <List>
      <DataTable>
        <DataTableHead>
          <DataTableRow>
            <DataTableCell>Report Date</DataTableCell>
            <DataTableCell>View Count</DataTableCell>
            <DataTableCell>Click Count</DataTableCell>
            <DataTableCell>Bookmark Count</DataTableCell>
          </DataTableRow>
        </DataTableHead>
        <DataTableBody>
          {#each reportsInfoResponse.docs as report}
            <DataTableRow>
              <DataTableCell>
                <ListItem on:click={() => openReportPage(report)}
                  >{dayjs(report.date).format('DD MMM, dddd')}</ListItem
                >
              </DataTableCell>
              {#if response}
                <DataTableCell>
                  <ListItem on:click={() => openReportPage(report)}>
                    {filterViewCount(response, report.date, 'REPORT_OPEN')}
                  </ListItem>
                </DataTableCell>
                <DataTableCell>
                  <ListItem on:click={() => openReportPage(report)}>
                    {filterViewCount(response, report.date, 'ITEM_CLICK')}
                  </ListItem>
                </DataTableCell>
                <DataTableCell>
                  <ListItem on:click={() => openReportPage(report)}>
                    {filterViewCount(response, report.date, 'BOOKMARK_ADD')}
                  </ListItem>
                </DataTableCell>
              {/if}
            </DataTableRow>
          {/each}
        </DataTableBody>
      </DataTable>
    </List>
  {/if}
</Scroller>
